import React, { useEffect, useState } from "react";
import { Container, Boxs } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdVisibility, MdDelete, MdLink } from "react-icons/md";
import { useAuth } from "../../../hooks/AuthContext";
import { format } from "date-fns";
import { Button, Input, Pagination, Spin, Modal, Tooltip } from "antd";
import { Card, Message, ViewInput } from "../../../GlobalStyles";
import Status from "../../../components/status";
import copy from "copy-to-clipboard";
import { ExclamationCircleFilled } from "@ant-design/icons";
import CountUp from "react-countup";

const { confirm } = Modal;

export default function ContractsAdmin() {
  const { user } = useAuth();
  const { user_id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [contracts, setContracts] = useState([]);
  const [contractsC, setContractsC] = useState([]);
  const [filtername, setFilterName] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (user.type !== "admin") {
      navigate(-1);
    } else {
      listContracts();
    }
  }, []);

  async function listContracts() {
    setLoading(true);
    await api
      .get(`/contracts/${user_id}`)
      .then((response) => {
        setContracts(response.data.contracts);
        setContractsC(response.data.contracts);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  function filterContracts(value, currentStatus) {
    let filtered = contractsC;

    if (value) {
      filtered = filtered.filter(
        (item) =>
          String(item.name).toUpperCase().indexOf(value.toUpperCase()) !== -1,
      );
    }

    if (currentStatus) {
      filtered = filtered.filter((item) => item.status === currentStatus);
    }

    setContracts(filtered);
  }

  async function deleteContract(id) {
    await api
      .delete(`/contract/${id}`)
      .then(() => {
        toast.success("Contrato excluido com sucesso");
        listContracts();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  const handleStatusClick = (selectedStatus) => {
    const newStatus = status === selectedStatus ? "" : selectedStatus;
    setStatus(newStatus);
    filterContracts(filtername, newStatus);
  };

  return (
    <Container>
      <h1>Contratos do Franqueado</h1>

      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 50 }}>
          <Spin size="large" color="#008037" />
        </div>
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={contracts.length} />
          </Card>

          <div className="filters-row">
            <ViewInput style={{ flex: 1, maxWidth: 350 }}>
              <p>Pesquisar por Razão Social</p>
              <Input.Search
                value={filtername}
                onChange={(e) => {
                  setFilterName(e.target.value);
                  filterContracts(e.target.value, status);
                }}
                placeholder="pesquisar"
                allowClear
                enterButton
                style={{ borderRadius: 8 }}
              />
            </ViewInput>
          </div>

          <Boxs>
            <div
              style={{ background: "#46E961" }}
              className={status === "assinado" ? "active" : ""}
              onClick={() => handleStatusClick("assinado")}
            >
              <p>
                Assinados{" "}
                {contractsC.filter((c) => c.status === "assinado").length}
              </p>
            </div>
            <div
              style={{ background: "#46ADE9" }}
              className={status === "aguardando" ? "active" : ""}
              onClick={() => handleStatusClick("aguardando")}
            >
              <p>
                Aguardando{" "}
                {contractsC.filter((c) => c.status === "aguardando").length}
              </p>
            </div>
            <div
              style={{ background: "#FF5D5D" }}
              className={status === "recusado" ? "active" : ""}
              onClick={() => handleStatusClick("recusado")}
            >
              <p>
                Recusados{" "}
                {contractsC.filter((c) => c.status === "recusado").length}
              </p>
            </div>
            <div
              style={{ background: "#9D9D9D" }}
              className={status === "expirado" ? "active" : ""}
              onClick={() => handleStatusClick("expirado")}
            >
              <p>
                Expirados{" "}
                {contractsC.filter((c) => c.status === "expirado").length}
              </p>
            </div>
          </Boxs>

          {contracts.length === 0 ? (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
                border: "1px solid #eee",
              }}
            >
              <Message>Nenhum contrato encontrado.</Message>
            </div>
          ) : (
            <div className="contracts-list">
              {contracts.map((item) => (
                <div className="contract-card" key={item.id}>
                  <div className="main-info">
                    <Tooltip title={item.name}>
                      <strong>{item.name}</strong>
                    </Tooltip>
                    <span>Contrato Admin</span>
                  </div>

                  <div className="info-item">
                    <label>Telefone</label>
                    <span>{item.phone_number || "Não informado"}</span>
                  </div>

                  <div className="info-item">
                    <label>Status</label>
                    <Status
                      status={item.status}
                      isPayment={false}
                      style={{
                        fontSize: 10,
                        height: 18,
                        paddingBottom: 2,
                        width: "fit-content",
                      }}
                    />
                  </div>

                  <div className="info-item">
                    <label>Atualização</label>
                    <span>
                      {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                    </span>
                  </div>

                  <div className="actions">
                    <Tooltip title="Visualizar">
                      <Button
                        shape="circle"
                        icon={<MdVisibility size={18} />}
                        onClick={() => navigate(`/contract/${item.id}`)}
                      />
                    </Tooltip>
                    <Tooltip title="Copiar Link">
                      <Button
                        shape="circle"
                        icon={<MdLink size={18} />}
                        onClick={() => {
                          copy(
                            `https://app.gurusegead.com.br/contract/${item.id}`,
                          );
                          toast.success(
                            "Link do contrato copiado com sucesso!",
                          );
                        }}
                      />
                    </Tooltip>
                    {item.status !== "assinado" && (
                      <Tooltip title="Excluir">
                        <Button
                          shape="circle"
                          danger
                          icon={<MdDelete size={18} />}
                          onClick={() => {
                            confirm({
                              okText: "Confirmar",
                              title: `Deseja excluir o contrato de ${item.name}?`,
                              icon: <ExclamationCircleFilled />,
                              content: `Após confirmação o contrato será excluido`,
                              onOk() {
                                deleteContract(item.id);
                              },
                              onCancel() {},
                              cancelText: "Cancelar",
                            });
                          }}
                        />
                      </Tooltip>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </Container>
  );
}
